import { useContext } from 'react';
import { ProjectMembers } from 'api/project';
import { SquadContext } from 'contexts';

export const useSquad = (): ProjectMembers => {
  const ctx = useContext<ProjectMembers>(SquadContext);

  if (!ctx) {
    throw new Error('Please use this hook inside the SquadContext.Provider');
  }

  return ctx;
};
